module.exports = __webpack_public_path__ + "img/img15.afe53635.png";